<ng-container *transloco="let t">
    <vds-drawer #drawer (close)="hideDrawer.emit()" [config]="drawerConfig()" [open]="open()">
        <ng-template #drawerTitle>
            <span class="text-20 text-white">Vestas<span class="font-semibold">Online</span></span>
        </ng-template>
        <vds-main-nav (close)="drawer.closeDrawer()" [title]="drawerTitle" class="size-full">
            <nav [attr.aria-label]="t('siteNavigation')">
                <ul>
                    <li class="py-2">
                        <a routerLink="/app/jumpboard" routerLinkActive="vds-nav-item--active" vds-main-nav-item>
                            <vds-icon name="home" />
                            {{ t("home") }}
                        </a>
                    </li>
                    <li *voIsAdmin class="py-2">
                        <a href="https://accountsettings.vestas.com/" rel="noopener noreferrer" target="_blank" vds-main-nav-item>
                            <vds-icon name="usergroup" />
                            <span>{{ t("userManagement") }}</span>
                        </a>
                    </li>
                    <li *applicationAllowed="applicationIds.CaseManagement" class="py-2">
                        <a
                            routerLink="support"
                            ampRouterEvent
                            ampEventContext="Support - nav link"
                            routerLinkActive="vds-nav-item--active"
                            vds-main-nav-item
                        >
                            <vds-icon name="task-tools" />
                            <span>{{ t("caseManagementName") }}</span>
                        </a>
                    </li>
                </ul>
            </nav>

            <ng-container *featureFlag="'monthly-report-prototype'; else operationsByApplications">
                <ng-container [ngTemplateOutlet]="operationsSection" />
            </ng-container>

            <ng-template #operationsByApplications>
                <div
                    *hasAllowedApplications="[
                        applicationIds.ServicePlanning,
                        applicationIds.SoftwareManagement,
                        applicationIds.MonthlyReports,
                        applicationIds.BladeAssetManagement,
                        applicationIds.ContractualAvailability,
                        applicationIds.Invoices
                    ]"
                >
                    <ng-container [ngTemplateOutlet]="operationsSection" />
                </div>
            </ng-template>

            <ng-template #operationsSection>
                <div class="px-8 py-12">
                    <span class="text-14 font-bold text-white" id="voOperations">{{ t("operations") }}</span>
                </div>
                <nav aria-labelledby="voOperations">
                    <ul>
                        <ng-container *featureFlag="'monthly-report-prototype'">
                            <li class="py-2">
                                <a
                                    routerLink="monthly-report-prototype"
                                    routerLinkActive="vds-nav-item--active"
                                    ampRouterEvent
                                    ampEventContext="Monthly Report Prototype - nav link"
                                    vds-main-nav-item
                                >
                                    <vds-icon name="report-data" />
                                    <span>{{ t("monthlyReports") }}</span>
                                    <vds-status class="ml-auto" color="blue" mode="dark" simple>{{ t("beta") }}</vds-status>
                                </a>
                            </li>
                        </ng-container>

                        <li *applicationAllowed="applicationIds.ServicePlanning" class="py-2">
                            <a
                                routerLink="planning-and-maintenance"
                                routerLinkActive="vds-nav-item--active"
                                ampRouterEvent
                                ampEventContext="PAM - nav link"
                                vds-main-nav-item
                            >
                                <vds-icon name="calendar-tools" />
                                <span>{{ t("planningAndMaintenance") }}</span>
                            </a>
                        </li>
                        <li *applicationAllowed="applicationIds.SoftwareManagement" class="py-2">
                            <a
                                routerLink="software-management"
                                routerLinkActive="vds-nav-item--active"
                                ampRouterEvent
                                ampEventContext="SWM - nav link"
                                vds-main-nav-item
                            >
                                <vds-icon name="material-scada" />
                                <span>{{ t("softwareManagement") }}</span>
                            </a>
                        </li>
                        <li *applicationAllowed="applicationIds.MonthlyReports" class="py-2">
                            <a routerLink="monthly-report" routerLinkActive="vds-nav-item--active" vds-main-nav-item>
                                <vds-icon name="report-data" />
                                <span>{{ t("monthlyReports") }}</span>
                            </a>
                        </li>

                        <li *applicationAllowed="applicationIds.BladeAssetManagement" class="py-2">
                            <a routerLink="bam" routerLinkActive="vds-nav-item--active" vds-main-nav-item>
                                <vds-icon name="turbine" />
                                <span>{{ t("voAppNameP020A_UBI") }}</span>
                            </a>
                        </li>

                        <ng-container *featureFlag="'contractual-availability'">
                            <li *applicationAllowed="applicationIds.ContractualAvailability" class="py-2">
                                <a routerLink="contractual-availability" routerLinkActive="vds-nav-item--active" vds-main-nav-item>
                                    {{ t("contractualAvailability") }}
                                </a>
                            </li>
                        </ng-container>

                        <li *applicationAllowed="applicationIds.Invoices" class="py-2">
                            <a routerLink="finances" routerLinkActive="vds-nav-item--active" vds-main-nav-item>
                                <vds-icon name="account" />
                                <span>{{ t("voAppNameP019A_INV") }}</span>
                            </a>
                        </li>
                    </ul>
                </nav>
            </ng-template>
            <div
                *hasAllowedApplications="[applicationIds.Workspaces, applicationIds.TechnicalLibrary, applicationIds.ProjectPlanningPortal]"
            >
                <div class="px-8 py-12">
                    <span class="text-14 font-bold text-white" id="voDocumentSharing">{{ t("documentSharing") }}</span>
                </div>
                <nav aria-labelledby="voDocumentSharing">
                    <ul>
                        <li *applicationAllowed="applicationIds.Workspaces" class="py-2">
                            <a routerLink="workspace" routerLinkActive="vds-nav-item--active" vds-main-nav-item>
                                <vds-icon name="folder-shared" />
                                <span>{{ t("voAppNameP007A_COL") }}</span>
                            </a>
                        </li>

                        <li *applicationAllowed="applicationIds.TechnicalLibrary" class="py-2">
                            <a routerLink="technical-library" routerLinkActive="vds-nav-item--active" vds-main-nav-item>
                                <vds-icon name="tools" />
                                <span>{{ t("voAppNameP017A_TECHLIB") }}</span>
                            </a>
                        </li>

                        <li *applicationAllowed="applicationIds.ProjectPlanningPortal" class="py-2">
                            <a routerLink="sales-documentation" routerLinkActive="vds-nav-item--active" vds-main-nav-item>
                                <vds-icon name="wind-power" />
                                <span>{{ t("projectPlanningPortal") }}</span>
                            </a>
                        </li>
                    </ul>
                </nav>
            </div>
            <div *hasAllowedApplications="[applicationIds.Toolkit]">
                <div class="px-8 py-12">
                    <span class="text-14 font-bold text-white" id="voMarketPlace">{{ t("marketPlace") }}</span>
                </div>
                <nav aria-labelledby="voMarketPlace">
                    <ul>
                        <li *applicationAllowed="applicationIds.Toolkit" class="py-2">
                            <a routerLink="toolkit" routerLinkActive="vds-nav-item--active" vds-main-nav-item>
                                <vds-icon name="api" />
                                <span>{{ t("toolkit") }}</span>
                            </a>
                        </li>
                    </ul>
                </nav>

                <div class="my-8 h-px w-full border-t border-t-gray-700"></div>
            </div>
            <div class="mt-auto">
                <button (click)="showLegalNotice()" class="w-full" type="button" vds-main-nav-item>
                    <vds-icon name="white-paper" />
                    <span>{{ t("termsOfUse") }}</span>
                </button>
                <nav [attr.aria-label]="t('externalApplications')">
                    <ul>
                        <li class="py-2">
                            <a href="https://shop.vestas.com" rel="noopener noreferrer" target="_blank" vds-main-nav-item>
                                <span>ShopVestas</span>
                                <vds-icon class="ml-auto" name="external" />
                            </a>
                        </li>
                    </ul>
                </nav>
            </div>
        </vds-main-nav>
    </vds-drawer>
</ng-container>
